"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const locale = {
  placeholder: 'အချိန်ရွေးပါ။',
  rangePlaceholder: ['စတင်ချိန်', 'ကုန်ဆုံးချိန်']
};
var _default = exports.default = locale;